/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type WireframeAuditRead = {
    id: number;
    audit_type: WireframeAuditRead.audit_type;
    action: string;
    profile_id: (number | null);
    workstream_id: (number | null);
    pillar_workstream_id: (number | null);
    actor_user_id: string;
    before_snapshot: any;
    after_snapshot: any;
    occurred_at: string;
};

export namespace WireframeAuditRead {

    export enum audit_type {
        COST_PROFILE = 'cost_profile',
        HEADCOUNT_DATA = 'headcount_data',
    }


}

